import type { RadarLocale } from '@/i18n/radarLanding';

const english = {
  title: 'Suggested next step',
  loading: 'Loading saved suggestion…',
  awaiting: 'A suggestion will appear automatically after the next scheduled check.',
  stale: 'The evidence or contact options have changed. The suggestion will update after the next scheduled check.',
  failed: 'The latest analysis did not finish. The collected signals remain available; analysis will run again at the next scheduled check.',
  error: 'The saved suggestion could not be loaded. It will be checked again when you reopen this company.',
  empty: 'There is not enough signal evidence for a concrete suggestion yet.',
  incomplete: 'The latest check did not fully complete.',
  role: 'Who to approach', goal: 'Aim for this reply', message: 'Suggested opener',
  start: 'Start here', personNote: 'Their current role is verified. Ask whether they handle this product decision.',
  mailboxNote: 'Send the opener to this company mailbox and ask for it to be forwarded to the person described below.',
  websiteNote: 'No named contact is confirmed. Open the company website, look for a contact option, and use the opener below to request a referral.',
  openWebsite: 'Open company website', openMailbox: 'View mailbox source', openPerson: 'Open LinkedIn profile',
  copy: 'Copy opener', copied: 'Copied', copyFailed: 'Select the opener and copy it manually.',
  contacts: 'View contact options', reconsider: 'Reconsider when',
  evidence: 'Why this suggestion', confirmed: 'Source checked', pending: 'Needs confirmation',
  prepared: 'Prepared',
};
const simplified: typeof english = {
  title: '建议下一步', loading: '正在读取已保存的建议…',
  awaiting: '下次定期检查完成后，建议会自动显示在这里。',
  stale: '证据或联系入口已有变化，建议会在下次定期检查后自动更新。',
  failed: '本次分析未完成，已收集的信号仍可查看；下次定期检查时会重新分析。',
  error: '暂时无法读取已保存的建议，重新打开这家公司时会再次读取。', empty: '现有信号不足以给出具体建议。',
  incomplete: '最近检查尚未完整完成。', role: '建议联系角色', goal: '希望得到的回复',
  start: '从这里开始', personNote: '已核实此人的当前职位；先询问是否由其负责这类产品的评估。',
  mailboxNote: '向这个公司邮箱发送下方话术，请其转交给负责下述业务的人。',
  websiteNote: '目前没有已确认的具体联系人。先打开公司官网查找联系入口，再用下方话术请求转交。',
  openWebsite: '打开公司官网', openMailbox: '查看邮箱出处', openPerson: '打开 LinkedIn 主页',
  message: '可以这样开场', copy: '复制话术', copied: '已复制', copyFailed: '请选中话术并手动复制。',
  contacts: '查看联系入口', reconsider: '出现什么变化后再考虑',
  evidence: '这条建议的依据', confirmed: '原文已核实', pending: '待核实', prepared: '生成于',
};
const traditional: typeof english = {
  title: '建議下一步', loading: '正在讀取已儲存的建議…',
  awaiting: '下次定期檢查完成後，建議會自動顯示在這裡。',
  stale: '證據或聯絡管道已有變化，建議會在下次定期檢查後自動更新。',
  failed: '本次分析未完成，已收集的訊號仍可查看；下次定期檢查時會重新分析。',
  error: '暫時無法讀取已儲存的建議，重新開啟這家公司時會再次讀取。', empty: '現有訊號不足以給出具體建議。',
  incomplete: '最近檢查尚未完整完成。', role: '建議聯絡角色', goal: '希望得到的回覆',
  start: '從這裡開始', personNote: '已核實此人的目前職位；先詢問是否由其負責這類產品的評估。',
  mailboxNote: '向這個公司信箱傳送下方話術，請其轉交給負責下述業務的人。',
  websiteNote: '目前沒有已確認的具體聯絡人。先開啟公司官網尋找聯絡管道，再用下方話術請求轉交。',
  openWebsite: '開啟公司官網', openMailbox: '查看信箱出處', openPerson: '開啟 LinkedIn 頁面',
  message: '可以這樣開場', copy: '複製話術', copied: '已複製', copyFailed: '請選取話術並手動複製。',
  contacts: '查看聯絡管道', reconsider: '出現什麼變化後再考慮',
  evidence: '這項建議的依據', confirmed: '原文已核實', pending: '待核實', prepared: '產生於',
};

export function monitoringAdviceCopy(locale: RadarLocale) {
  return locale === 'zh-Hans' ? simplified : locale === 'zh-Hant' ? traditional : english;
}
